/**
 * Internal platform roles - соответствует бэкенду
 * Файл: C:\EventOS\new-backend-1.3\src\modules\auth\enums\internal-roles.enum.ts
 * CRITICAL: Значения ДОЛЖНЫ быть в UPPERCASE для совместимости с бекендом
 */

export enum InternalRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  PLATFORM_MANAGER = 'PLATFORM_MANAGER',
  CONTENT_MODERATOR = 'CONTENT_MODERATOR',
  SUPPORT_AGENT = 'SUPPORT_AGENT',
  SECURITY_ADMIN = 'SECURITY_ADMIN',
  TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
  CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS',
  PRODUCT_MANAGER = 'PRODUCT_MANAGER',
  DEVELOPER = 'DEVELOPER',
  QA_ENGINEER = 'QA_ENGINEER',
  OPERATIONS_MANAGER = 'OPERATIONS_MANAGER',
  MONITORING_ENGINEER = 'MONITORING_ENGINEER',
  COMMUNITY_MANAGER = 'COMMUNITY_MANAGER'
}

// LEVEL_1 = highest authority (SUPER_ADMIN), ascending numbers = decreasing authority.
// Matches backend: src/modules/auth/enums/internal-roles.enum.ts
export enum InternalRoleLevel {
  LEVEL_1 = 1, // SUPER_ADMIN
  LEVEL_2 = 2, // PLATFORM_ADMIN, SECURITY_ADMIN
  LEVEL_3 = 3, // PLATFORM_MANAGER, PRODUCT_MANAGER, OPERATIONS_MANAGER
  LEVEL_4 = 4, // CONTENT_MODERATOR, TECHNICAL_SUPPORT, CUSTOMER_SUCCESS
  LEVEL_5 = 5, // SUPPORT_AGENT, DEVELOPER, QA_ENGINEER, MONITORING_ENGINEER
  LEVEL_6 = 6, // COMMUNITY_MANAGER
}

/**
 * Ключи подписей внутренних ролей (AD-472). Значение перечисления — идентификатор
 * протокола (`SUPPORT_AGENT`), человеку его показывать нечем, пока подпись не
 * объявлена. Карта, а не сборка ключа строкой: компилятор требует подпись на
 * каждую роль, а гейт `scan:i18n-keys` видит ключи литералами.
 */
export const INTERNAL_ROLE_LABEL_KEYS: Record<InternalRole, string> = {
  [InternalRole.SUPER_ADMIN]: 'roles.internal.superAdmin',
  [InternalRole.PLATFORM_ADMIN]: 'roles.internal.platformAdmin',
  [InternalRole.PLATFORM_MANAGER]: 'roles.internal.platformManager',
  [InternalRole.CONTENT_MODERATOR]: 'roles.internal.contentModerator',
  [InternalRole.SUPPORT_AGENT]: 'roles.internal.supportAgent',
  [InternalRole.SECURITY_ADMIN]: 'roles.internal.securityAdmin',
  [InternalRole.TECHNICAL_SUPPORT]: 'roles.internal.technicalSupport',
  [InternalRole.CUSTOMER_SUCCESS]: 'roles.internal.customerSuccess',
  [InternalRole.PRODUCT_MANAGER]: 'roles.internal.productManager',
  [InternalRole.DEVELOPER]: 'roles.internal.developer',
  [InternalRole.QA_ENGINEER]: 'roles.internal.qaEngineer',
  [InternalRole.OPERATIONS_MANAGER]: 'roles.internal.operationsManager',
  [InternalRole.MONITORING_ENGINEER]: 'roles.internal.monitoringEngineer',
  [InternalRole.COMMUNITY_MANAGER]: 'roles.internal.communityManager'
};

export const INTERNAL_ROLE_LEVELS: Record<InternalRole, InternalRoleLevel> = {
  [InternalRole.SUPER_ADMIN]: InternalRoleLevel.LEVEL_1,
  [InternalRole.PLATFORM_ADMIN]: InternalRoleLevel.LEVEL_2,
  [InternalRole.PLATFORM_MANAGER]: InternalRoleLevel.LEVEL_3,
  [InternalRole.CONTENT_MODERATOR]: InternalRoleLevel.LEVEL_4,
  [InternalRole.SUPPORT_AGENT]: InternalRoleLevel.LEVEL_5,
  [InternalRole.SECURITY_ADMIN]: InternalRoleLevel.LEVEL_2,
  [InternalRole.TECHNICAL_SUPPORT]: InternalRoleLevel.LEVEL_4,
  [InternalRole.CUSTOMER_SUCCESS]: InternalRoleLevel.LEVEL_4,
  [InternalRole.PRODUCT_MANAGER]: InternalRoleLevel.LEVEL_3,
  [InternalRole.DEVELOPER]: InternalRoleLevel.LEVEL_5,
  [InternalRole.QA_ENGINEER]: InternalRoleLevel.LEVEL_5,
  [InternalRole.OPERATIONS_MANAGER]: InternalRoleLevel.LEVEL_3,
  [InternalRole.MONITORING_ENGINEER]: InternalRoleLevel.LEVEL_5,
  [InternalRole.COMMUNITY_MANAGER]: InternalRoleLevel.LEVEL_6,
};

export const INTERNAL_ROLE_DESCRIPTIONS: Record<InternalRole, string> = {
  [InternalRole.SUPER_ADMIN]: 'Супер администратор платформы',
  [InternalRole.PLATFORM_ADMIN]: 'Администратор платформы',
  [InternalRole.PLATFORM_MANAGER]: 'Менеджер платформы',
  [InternalRole.CONTENT_MODERATOR]: 'Модератор контента',
  [InternalRole.SUPPORT_AGENT]: 'Агент поддержки',
  [InternalRole.SECURITY_ADMIN]: 'Администратор безопасности',
  [InternalRole.TECHNICAL_SUPPORT]: 'Техническая поддержка',
  [InternalRole.CUSTOMER_SUCCESS]: 'Менеджер по работе с клиентами',
  [InternalRole.PRODUCT_MANAGER]: 'Продуктовый менеджер',
  [InternalRole.DEVELOPER]: 'Разработчик',
  [InternalRole.QA_ENGINEER]: 'QA инженер',
  [InternalRole.OPERATIONS_MANAGER]: 'Менеджер операций',
  [InternalRole.MONITORING_ENGINEER]: 'Инженер мониторинга',
  [InternalRole.COMMUNITY_MANAGER]: 'Менеджер сообщества'
};
